import { render } from "./TextualShelf.vue?vue&type=template&id=a27c86f6&scoped=true"
import script from "./TextualShelf.vue?vue&type=script&lang=js"
export * from "./TextualShelf.vue?vue&type=script&lang=js"

import "./TextualShelf.vue?vue&type=style&index=0&id=a27c86f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a27c86f6"]])

export default __exports__